export default {
  loginWelcome: `Multicultural Center of Marin welcomes you.` 
}


// WEBPACK FOOTER //
// ./src/static/notifications/index.js